<lp-product-request-info
  *ngIf="selectedProductRequestId || productRequestMode === 'create'; else ProductRequestListTmp"
  [mode]="productRequestMode"
  [id]="selectedProductRequestId"
  (cancelEditing)="onCancelEditing()"
  (saved)="onSaveProductRequest()"
  (deleted)="onDeleteProductRequest()"
  (onClickEditButton)="onClickEditButton()"
></lp-product-request-info>

<ng-template #ProductRequestListTmp>
  <lp-product-request-list
    (onSelectItem)="onSelectProductRequest($event)"
    (startCreate)="onClickCreateButton()"
  ></lp-product-request-list>
</ng-template>
